module.exports = __webpack_public_path__ + "static/img/ig.ddfc7cb0.png";